import type { ConsentsFeatureConfig } from './type';

export const consents: Partial<ConsentsFeatureConfig> = {
    showPrintInDetail: true,
};
